import React, { useMemo, useCallback, FC } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
  COMPANY_TYPES,
  CompanyTypeOption,
  DEFAULT_ENTITY_TYPE_FILTER_VALUE,
} from "../constants";
import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { getCompanyTypeOption } from "./utils";

interface CompanyTypeFilterOptionsProps {
  value: EntityTypeFilterValue;
  onChange: (value: EntityTypeFilterValue) => void;
  noClearButton?: boolean;
  noTitle?: boolean;
}

export const CompanyTypeFilterOptions: FC<CompanyTypeFilterOptionsProps> = (
  props
) => {
  const selectedCompanyTypeOption = useMemo(() => {
    return getCompanyTypeOption(props.value);
  }, [props.value]);

  const handleCompanyTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedOption = event.target.value as CompanyTypeOption;

      const value = { ...DEFAULT_ENTITY_TYPE_FILTER_VALUE };

      if (selectedOption === CompanyTypeOption.GHQ) {
        value.isGhq = true;
      } else if (selectedOption === CompanyTypeOption.CP) {
        value.isGp = true;
      } else if (selectedOption === CompanyTypeOption.DP) {
        value.isDp = true;
      }

      props.onChange(value);
    },
    [props]
  );

  const handleClearFilter = () => {
    props.onChange(DEFAULT_ENTITY_TYPE_FILTER_VALUE);
  };

  return (
    <Box id="company-type-filter-options">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {!props.noTitle && <Typography variant="h5">Company Type</Typography>}
        {!props.noClearButton && (
          <Button size="medium" variant="text" onClick={handleClearFilter}>
            Clear
          </Button>
        )}
      </Stack>

      <RadioGroup
        value={selectedCompanyTypeOption}
        onChange={handleCompanyTypeChange}
      >
        {COMPANY_TYPES.map((companyType) => (
          <FormControlLabel
            key={companyType.value}
            value={companyType.value}
            id={`entity-type-option-${companyType.label}`}
            control={
              <Radio
                data-testid={`company-type-option-${companyType.value}-radio`}
              />
            }
            label={
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography>{companyType.label}</Typography>
                <Tooltip title={companyType.tooltip} arrow>
                  <IconButton size="small">
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Stack>
            }
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
